import { Reservation, User } from '@ciao/console/src/swagger/models';
import { Interval } from 'luxon';
import { MarkerStatus, WBMarker } from './types';
import { getFreeTimeInInterval, getReservationIntervals } from './util';

export const enhanceMarkerWithReservationInfo = (
	marker: WBMarker,
	reservations: Reservation[],
	interval: Interval,
): WBMarker => {
	marker.reservations = reservations;

	const reservationIntervals = reservations.map((r) => getReservationIntervals(r).reservationInterval);
	const freeTime = getFreeTimeInInterval(interval, reservationIntervals).get('milliseconds');

	// If all of the reservations have checked out, don't do anything
	if (!reservations.some((r) => !r.checkoutAt)) {
		// Don't run the other statements
		// Great code, huh? An empty if-statement to prevent others from running,
		// Big brain developer.
	}

	// Only one reservation
	else if (reservations.length === 1) {
		const user = <User>reservations[0].user;
		marker.currentReservation = reservations[0];
		marker.initials = marker.initials = `${user.firstName[0]}${user.lastName[0]}`.toUpperCase();
		if (freeTime > 0) marker.status = MarkerStatus.partiallyAvailable;
		else marker.status = MarkerStatus.reserved;
	}

	// Multiple reservations
	else if (reservations.length) {
		marker.initials = '…';
		if (freeTime > 0) marker.status = MarkerStatus.partiallyAvailable;
		else marker.status = MarkerStatus.reserved;
	}

	// No reservations -> available is default, don't overwrite it because we'd also overwrite unavailable
	// else if (!filteredReservations.length) {
	// 	marker.status = MarkerStatus.available;
	// }

	// If any of the reservations are currently checked in, change the marker color
	if (reservations.some((r) => r.checkinAt && !r.checkoutAt)) {
		marker.status = MarkerStatus.checkedIn;
	}

	return marker;
};
